import companySuppliers from './companySuppliers'

export default {
  companySuppliers,
}
